import { ADDITIONAL_DRIVER } from "actions/reservation/ADDITIONAL_DRIVER";

export const setIsSpouseAdditionalDriver = (data = false) => ({
    type: ADDITIONAL_DRIVER.SET_SPOUSE_ADDITIONAL_DRIVER,
    data,
});